import {createAction} from 'redux-actions'

const action = name => createAction(`industries-table/${name}`)

export const init = action('INIT')
export const deinit = action('REMOVE')

export const showIndustryDetailsModal = action('SHOW_INDUSTRY_DETAILS_MODAL')
export const hideIndustryDetailsModal = action('HIDE_INDUSTRY_DETAILS_MODAL')
